import { Group, Tooltip, UnstyledButton } from "@mantine/core";
import { PLATFORM_VK, PLATFORM_YOUTUBE, type Platform } from "../api";
import { PLATFORM_TITLES, usePlatformLogin } from "../platformLogin";
import youtubeIcon from "../assets/colored/youtube.png";
import vkIcon from "../assets/colored/vk.png";

const ICONS: Record<Platform, string> = { [PLATFORM_YOUTUBE]: youtubeIcon, [PLATFORM_VK]: vkIcon };

/**
 * One platform's login, from any page: a dot shows whether this session can
 * publish there, and clicking a logged-out one starts the login in a new tab
 * (the status is re-checked when this tab gets focus back).
 */
function PlatformBadge({ platform }: { platform: Platform }) {
  const { ok, login } = usePlatformLogin(platform);
  const title = PLATFORM_TITLES[platform];
  const label = ok === null ? `${title}: проверяем вход…` : ok ? `${title}: вход выполнен` : `${title}: нет входа — нажмите, чтобы войти`;
  const state = ok === null ? "checking" : ok ? "ok" : "off";
  return (
    <Tooltip label={label} withArrow openDelay={200}>
      <UnstyledButton className="platform-badge" data-state={state} onClick={ok === false ? login : undefined} aria-label={label}>
        <img src={ICONS[platform]} alt="" />
        <span className="platform-badge-dot" />
      </UnstyledButton>
    </Tooltip>
  );
}

export function PlatformStatus() {
  return (
    <Group gap={6} wrap="nowrap">
      <PlatformBadge platform={PLATFORM_YOUTUBE} />
      <PlatformBadge platform={PLATFORM_VK} />
    </Group>
  );
}
